import "formdata-polyfill";
import { v4 as uuid } from "uuid";
// library imports

import { scroll } from "./scroll";
import { humanDate } from "./humanDate";
import { notify } from "./notify";
import { dimmer } from "./dimmer";
import { presentBlurbs } from "./presentBlurbs";
import { fetchMedia } from "./fetchMedia";
import { request } from "./request";
import { cModal } from "./modal";
import { languages, assetHost, api, status } from "../app";

let editValues;
let uploadedImgs = [];
let videos = [];

export const buildBlurbEditor = async (blurbs, id, editLang = "en", author, userLevel, blurb = {}) => {
	$("#blurb_editor").remove();
	// remove any existing blurb editor

	if (tinymce && tinymce.get("item")) {
		tinymce.get("item").destroy();
	}
	// destroy tinyMCE editor instance if it exists

	let now = new Date().getTime();

	if (id) {
		blurb = blurbs.find(item => item.id === id);
		// blurb now is the blurb's global values

		editValues = blurb.langs[editLang]
			? blurb.langs[editLang]
			: {
					created: now,
					pubDate: now,
					id: id,
					thumb: blurb.langs.en && blurb.langs.en.thumb ? JSON.parse(JSON.stringify(blurb.langs.en.thumb)) : [],
					lang: editLang,
					headline: "",
					item: "",
					updated: now,
					createdBy: author,
					status: false
			  };
		// editValues now holds this blurb's lang-based values;
		// if this is the first blurb for this lang, most values
		// are zeroed out, but any thumbs carry over
	} else {
		// this is a new blurb, or,
		// there might still be a blurb in-memory if
		// this build is from a lang select change

		if (blurb.langs && blurb.langs[editLang]) {
			editValues = blurb.langs[editLang];
		} else {
			editValues = {
				created: now,
				pubDate: now,
				updated: now,
				thumb: blurb && blurb.langs && blurb.langs.en && blurb.langs.en.thumb ? blurb.langs.en.thumb : [],
				lang: editLang,
				headline: "",
				item: "",
				createdBy: author,
				status: false
			};
		}
	}
	let clonedVals = JSON.parse(JSON.stringify(editValues));
	if (blurb.langs) {
		blurb.langs[editLang] = clonedVals;
	} else {
		blurb.langs = {
			[editLang]: clonedVals
		};
	}
	// make sure the lang key in this blurb object
	// has these editValues

	let blurbEditor = $(`<div id="blurb_editor" class="uk-section uk-section-muted uk-padding-small">
            <div data-wrapper="form wrapper">
            <h3>Corporate Responsibility Item Editor</h3><hr/>
                <form data-lang="${editLang}" uk-grid class="uk-grid-small uk-margin-top" id="blurb_form" name="blurb_form" enctype="multipart/form-data" autocomplete="off"></form>
            </div>
        </div>`);
	// instantiate blurb editor

	$("#cr_editor_wrapper").html(blurbEditor);
	scroll(blurbEditor, 200);

	let form = blurbEditor.find("#blurb_form");
	form.append(`<div class="field uk-width-1-1 uk-width-1-6@s">
            <label for="language">Language</label>
            <select class="uk-select" name="lang" value="${editLang}">
                <option ${editLang === "en" ? "selected" : ""} value="en">English</option>
                <option ${editLang === "cn" ? "selected" : ""} value="cn">Chinese</option>
                <option ${editLang === "pt" ? "selected" : ""} value="pt">Portuguese</option>
                <option ${editLang === "ru" ? "selected" : ""} value="ru">Russian</option>
                <option ${editLang === "es" ? "selected" : ""} value="es">Spanish</option>
            </select>
        </div>
        <div class="field uk-width-1-1 uk-width-1-2@s">
            <label for="headline">Headline</label>
            <input id="headline" class="uk-input" name="headline" type="text" value="${editValues.headline}" placeholder="Headline">               
        </div>
        <div uk-grid class="field uk-grid-small uk-width-1-1 uk-width-1-3@s">
            <div class="uk-width-4-5 uk-padding-remove-horizontal">
                <label for="pubDate">Publish Date</label>
                <input id="pubDate" class="uk-input" type="date" value="${editValues.pubDate}" name="pubDate">
            </div>
            <div class="uk-width-1-5">
                <label for="status">Active</label>
                <input class="uk-checkbox" name="status" id="status" ${editValues.status ? "checked" : ""} type="checkbox">
            </div>
        </div>
        <div class="field uk-width-1-1">
            <label for="item">Item Copy</label>
            <textarea name="item" id="item">${editValues.item}</textarea>
        </div>
        <div class="field uk-width-1-1 uk-width-1-2@s">
            <div id="image_upload_wrapper" class="uk-position-relative">
                <label for="image">Thumbnails</label>
                <div class="uk-flex uk-flex-around uk-flex-wrap uk-margin" uk-sortable id="image_manager">
                    <span>No image selected</span>
                </div>
                <div class="js-upload uk-text-center">
                    <span uk-icon="icon: cloud-upload"></span>
                    <span class="uk-text-middle">Upload images by dropping them here or</span>
                    <div uk-form-custom>
                        <input type="file" multiple>
                        <span class="uk-link underline pointer">browse for them</span>
                    </div>
                    <progress id="imageProgress" class="uk-progress" value="0" max="100"></progress>
                </div>
            </div>
        </div>
        <div class="field uk-width-1-1 uk-width-1-2@s">
            <div id="video_search_wrapper" class="uk-position-relative">
                <label for="video">Video</label>
                <div class="uk-margin" id="video_manager">
                    <span>No video selected</span>
                </div>
                <select class="uk-select" id="video" name="video">
                    <option value="">Select video</option>
                </select>
                <p class="uk-margin-small-top uk-text-small"><span class="bold">IMPORTANT:</span> Selecting a video will override any thumbnail selections for this item.</p>
            </div>
        </div>
        <div id="form_errors" class="hidden uk-padding-small"></div>
        <div class="uk-align-left">
            <button class="uk-button uk-button-primary" data-button="submit blurb form">Submit</button> <button class="uk-button uk-button-danger" data-button="cancel blurb edit">Cancel</button> ${id ? `<button class="uk-button uk-button-danger" data-button="delete blurb">Delete</button>` : ""}
        </div>`);
	// instantiate form

	blurbEditor.find("[data-button='cancel blurb edit']").on("click", function (e) {
		e.preventDefault();
		blurbEditor.remove();
		$("#createBlurbButton").removeClass("hidden");
	});
	// cancel edit button click handler

	$(".flatpickr-calendar").remove();
	// get rid of any existing flatpickr calendars hanging around

	flatpickr("[name='pubDate']", {
		altInput: true,
		altFormat: "F j, Y at h:iK",
		dateFormat: "U",
		defaultDate: editValues.pubDate,
		enableTime: true
	});

	let videoSelect = blurbEditor.find("select[name='video']");
	try {
		// we use fetchMedia instead of direct
		// to request() because there is a pagination
		// step
		const response = await fetchMedia(
			{
				terms: "nat:video",
				expand: "asset_properties,file_properties,metadata,security,thumbnails,embeds"
			},
			[],
			true,
			$("#video_search_wrapper")
		);
		videos = response;
		if (videos.length) {
			videoSelect.append(videos.map(video => `<option value="${video.id}">${video.metadata.fields.newsroomDisplayName[0]}</option>`).join(""));
			videoSelect
				.select2({
					minimumResultsForSearch: Infinity
				})
				.on("change", function () {
					if ($(this).val()) {
						let video = videos.find(item => item.id === $(this).val());
						if (video) {
							blurb.langs[editLang].video = {
								embed: video.embeds.video_player.html,
								thumb: video.embeds.video_poster.url,
								id: video.id,
								name: `${video.metadata.fields[`newsroomDisplayName${editLang != "en" ? editLang.toUpperCase() : ""}`][0]}`
							};
							$("#video_manager").html(blurb.langs[editLang].video.embed);
						}
					} else {
						delete blurb.langs[editLang].video;
						$("#video_manager").html("");
					}
				});
			if (editValues.video) {
				videoSelect.val(editValues.video.id).trigger("change");
			}
			// if video, get it into video manager if this is an edit
		}
	} catch (err) {
		console.error("Error fetching media:", err);
		notify(trans("There was an error retrieving media assets."), "danger");
	}

	tinymce.init({
		license_key: "gpl",
		selector: "textarea#item",
		height: 300,
		skin: false,
		paste_as_text: true,
		content_css: `${location.pathname.indexOf("/dist/") > -1 ? `/dist/` : "/"}css/main.css`,
		plugins: "wordcount code autolink link lists paste",
		toolbar: "undo redo | bold italic underline strikethrough | formatselect | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist | link | removeformat | paste | code",
		menubar: "file edit view insert format tools",
		menu: {
			file: { title: "File", items: "newdocument restoredraft | preview | print " },
			edit: { title: "Edit", items: "undo redo | cut copy paste | selectall | searchreplace" },
			view: { title: "View", items: "code | visualaid visualchars visualblocks | spellchecker | preview fullscreen" },
			insert: { title: "Insert", items: "link" },
			format: { title: "Format", items: "bold italic underline strikethrough superscript subscript codeformat | formats blockformats fontsizes align | removeformat" },
			tools: { title: "Tools", items: "spellchecker spellcheckerlanguage | code wordcount" },
			help: { title: "Help", items: "help" }
		}
	});
	// initialize blurb item text editor

	const langSelect = blurbEditor
		.find("select[name='lang']")
		.select2({
			minimumResultsForSearch: Infinity
		})
		.on("change", function () {
			tinymce.get("item").save();
			// put editor copy into native textarea

			blurb.langs[editLang].headline = form.find("[name='headline']").val();
			blurb.langs[editLang].pubDate = parseInt(form.find("[name='pubDate']").val()) * 1000;
			blurb.langs[editLang].status = form.find("[name='status']").prop("checked");
			blurb.langs[editLang].item = form.find("[name='item']").val();
			// update blurb values to form
			// why no image, video or pos housekeeping here?
			// because image uploads, video selects and sorts
			// update blurb obj in real time

			buildBlurbEditor(blurbs, id, $(this).val(), author, userLevel, blurb);
		});
	// update form if language changes

	const manageImages = uploads => {
		if (uploads) {
			blurb.langs[editLang].thumb = blurb.langs[editLang].thumb.concat(uploads);
		}
		// sync blurb to incoming image array if
		// it has value (ie, something was uploaded)

		let images = blurb.langs[editLang].thumb;
		// convenience assignment

		let imageMgr = $("#image_manager").html("");
		// start with a clean slate

		if (images.length) {
			images.forEach(image => {
				let { filename, url, uploaded } = image;
				let imgCard = $(`<div class="image_card uk-margin uk-card uk-card-small uk-card-default uk-card-body uk-card-hover" data-filename="${filename}" data-url="${url}" data-uploaded="${uploaded}">
                    <span class="uk-position-right">
                        <span data-button="remove image" uk-icon="icon: trash"></span>
                    </span>
                    <div class="thumbnail_wrapper uk-align-middle">
                        <img src="${url}">
                    </div>
                    <div class="card_meta_wrapper uk-card-footer">
                        <div class="filename"><span class="bold">Filename:</span> <span class="breakable filename">${filename}</span></div>
                        <div class="created"><span class="bold">Uploaded:</span> ${humanDate(parseInt(uploaded))}</div>
                    </div>
                </div>`);
				imageMgr.append(imgCard);

				$("[data-button='remove image']").on("click", function () {
					let card = $(this).parents(".image_card");
					blurb.langs[editLang].thumb = blurb.langs[editLang].thumb.filter(item => item.url != card.attr("data-url"));
					card.remove();
				});
				// click handler for remove photo button
			});
			imageMgr.off("moved").on("moved", function () {
				blurb.langs[editLang].thumb = [];
				imageMgr.find(".image_card").each(function () {
					blurb.langs[editLang].thumb.push({
						url: $(this).attr("data-url"),
						filename: $(this).attr("data-filename"),
						uploaded: parseInt($(this).attr("data-uploaded"))
					});
				});
			});
			// if image is sorted, rebuild blurb thumbs array
			// with card info in post-sorted DOM order
		}
	};

	let imgDropZone = $(".js-upload");
	let bar = $("#imageProgress").hide();
	let postData = {
		bucket: "gulfstreamnews-data",
		key: "images/corporate_responsibility",
		tagging: encodeURI("dmSite=Gulfstream News&Developer=Kelly Davis&Name=Corporate Responsibility image&Project=Corporate Responsibility Item Manager"),
		storageclass: "INTELLIGENT_TIERING",
		acl: "public-read"
	};
	let method = "POST";
	uploadedImgs = [];

	let uploadOptions = {
		url: `${api}/s3/binary`,
		multiple: true,
		name: "files",
		mime: "image/*",
		allow: "*.(jpg|jpeg|png)",
		maxSize: 10000, // KB
		beforeSend: req => {
			req.method = method;
			req.xhr.withCredentials = true;
			req.responseType = "json";
			let fileData = req.data.get("files");
			const sanitizedName = fileData.name.replace(/[\+\s]/g, "-");
			req.data = new FormData();
			for (let key in postData) {
				req.data.append(key, postData[key]);
			}
			req.data.append("files", fileData, sanitizedName);
		},
		// load: e => {
		//     console.log(e);
		// },
		complete: xhr => {
			$("#image_upload_wrapper").find(".dimmer").remove();
			let response = typeof xhr.response === "string" ? JSON.parse(xhr.response) : xhr.response;
			if (response.success) {
				let _asset = response.data.files[0];
				uploadedImgs.push({
					filename: _asset.originalname,
					url: `${assetHost}/${_asset.key}`,
					uploaded: new Date().getTime()
				});
				notify(`Saved "${_asset.originalname}" to database.`, "success", "top-right", null, "uploads");
			} else {
				notify(`Could not save images to our server: ${response.data}`, "danger", "top-right", null, "uploads");
			}
		},
		loadStart: e => {
			$("#image_upload_wrapper").append(dimmer(2));
			bar.show();
			bar.attr({
				max: e.total,
				value: e.loaded
			});
		},
		progress: e => {
			bar.attr({
				max: e.total,
				value: e.loaded
			});
		},
		loadEnd: e => {
			bar.attr({
				max: e.total,
				value: e.loaded
			});
		},
		completeAll: req => {
			let response = typeof req.response === "string" ? JSON.parse(req.response) : req.response;
			if (response.success) {
				setTimeout(() => {
					bar.hide();
				}, 500);
				notify("All uploads completed", "success", "top-right", 3000, "uploads", true);
				manageImages(uploadedImgs);
			} else {
				notify(`There was an error: ${response.data}`, "danger", "top-right", 3000, "uploads", true);
			}
		},
		error: err => {
			console.error("Upload error:", err);
		},
		fail: err => {
			notify(err, "danger");
		},
		msgInvalidName: "Invalid file! Only jpg/jpeg and pngs are allowed here!",
		msgInvalidMime: "Invalid file! Only image files are allowed here!",
		msgInvalidSize: "This file is too big! Files must be under 10MB."
	};

	UIkit.upload(imgDropZone, uploadOptions);
	// initialize drop area for image uploads

	$("select[name='lang']").val(editLang ? editLang : "en");
	// set language as en default or incoming lang

	manageImages();
	// get image onto page if this is an edit

	form.find("[name]").on("input", function () {
		$(this).parents(".field").find("label").removeClass("error");
	});
	// interaction forgives errors

	$("[data-button='submit blurb form']").on("click", function (e) {
		e.preventDefault();
		processBlurb(form, blurbs, id, author, editLang, userLevel, blurb);
	});
	// submit blurb form click handler

	if (id) {
		$("[data-button='delete blurb']").on("click", async function (e) {
			e.preventDefault();
			try {
				await cModal(`<h3>Just checking ...</h3>
				You are about to delete the item "${editValues.headline}" for ALL languages. Confirm the deletion below:`);
				notify(`Deleting "${editValues.headline}" <span uk-spinner></span>`, "primary", "top-right", 3000, "blurb delete", true);
				const response = await request({
					reqId: "f7ace6c3-dc2b-47f4-9f08-b890a61739ea",
					id: id,
					datatype: "crItem"
				});
				notify(`Item "${editValues.headline}" successfully deleted`, "success");
				$("#cr_list_wrapper").find(`[id='${id}']`).remove();
				blurbs = blurbs.filter(item => item.id != id);
				// update DOM and in-memory blurbs array with a removal;
				// no need to to make another http request

				$("#blurb_editor").remove();
			} catch (err) {
				if (err) {
					console.error("Error deleting blurb:", err);
					notify("There was an error deleting this blurb", "danger");
				}
			}
		});
	}
	// delete blurb click handler (only if id exists)
};
// end buildBlurbEditor function

const processBlurb = async (form, blurbs, id, author, editLang, userLevel, blurb) => {
	let formMsg = $("#form_errors").addClass("hidden").html("");
	blurb.langs[editLang].headline = form.find("[name='headline']").val();
	blurb.langs[editLang].pubDate = parseInt(form.find("[name='pubDate']").val()) * 1000;
	blurb.langs[editLang].status = form.find("[name='status']").prop("checked");
	tinymce.get("item").save();
	// put editor copy into native textarea

	blurb.langs[editLang].item = form.find("[name='item']").val();
	// update current blurb object to form values

	let activeFields = blurb.langs[editLang].status ? ["headline", "item", "thumb"] : [];
	let invalids = [];
	form.find(".error").removeClass("error");
	activeFields.forEach(field => {
		if (field === "thumb" && !blurb.langs[editLang].thumb.length && !blurb.langs[editLang].video) {
			// no empty thumb if also no video

			invalids.push($("#image_upload_wrapper"));
			invalids.push($("#video_search_wrapper"));
		} else if (!blurb.langs[editLang][field]) {
			invalids.push($(`#${field}`));
		}
	});
	// current form invalids are stored

	let otherLangInvalids = {};
	for (let langKey in blurb.langs) {
		if (langKey != editLang && blurb.langs[langKey].status) {
			// this only matters if the blurb in
			// this lang is active

			activeFields.forEach(field => {
				if (field === "thumb" && !blurb.langs[langKey].thumb.length && !blurb.langs[editLang].video) {
					if (otherLangInvalids[langKey]) {
						otherLangInvalids[langKey].push("thumbnail or video");
					} else {
						otherLangInvalids[langKey] = ["thumbnail or video"];
					}
				} else if (!blurb.langs[langKey][field]) {
					if (otherLangInvalids[langKey]) {
						otherLangInvalids[langKey].push(field);
					} else {
						otherLangInvalids[langKey] = [field];
					}
				}
			});
		}
	}
	let otherLangInvalidKeys = Object.keys(otherLangInvalids);
	if (invalids.length || otherLangInvalidKeys.length) {
		if (invalids.length) {
			// current form had invalid entries

			invalids.forEach(invalidated => {
				invalidated.parents(".field").find("label").addClass("error");
			});
		}
		if (otherLangInvalidKeys.length) {
			// other langs for this blurb are active
			// but have invalid values

			formMsg.removeClass("hidden");
			let errorString = `<h3>There are some issues with this item</h3><div><p>${invalids.length ? `In addition to the issues highlighted in the form above, please address the language-specific problems shown below:` : `The current ${languages[editLang]}-language entry is all good, but please address the issues listed below for other languages:`}</p>`;
			otherLangInvalidKeys.forEach(langKey => {
				errorString += `<p class="bold underline">${languages[langKey]}</p><p>${otherLangInvalids[langKey].map(field => `"<span class="capitalize">${field}</span>" must have a value`).join("<br/>")}</p>`;
			});
			formMsg.html(errorString);
		}
		scroll(form, 150);
	} else {
		// no validation errors; let's move on

		try {
			await cModal(
				`<h4>Preview</h4><p>You are about to save ${editLang === "en" ? "an" : "a"} ${languages[editLang]}-language item with the following information:</p><p>Headline: ${blurb.langs[editLang].headline}</p><p>Copy: ${blurb.langs[editLang].item}</p><p>Publish date: ${humanDate(blurb.langs[editLang].pubDate)}</p><p>Status: ${blurb.langs[editLang].status === true ? "Active" : "Inactive"}</p><p>Thumbnail${blurb.langs[editLang].thumb && blurb.langs[editLang].thumb.length === 1 ? "" : "s"}:${blurb.langs[editLang].thumb && blurb.langs[editLang].thumb.length ? blurb.langs[editLang].thumb.map(thumb => `<br/><img style="width: 100%; max-width: 300px; height: auto;" src="${thumb.url}"/>`).join("") : " No thumbnails"}</p><p>Video: ${blurb.langs[editLang].video ? `<br/><div style="width: 100%; max-width:300px;">${blurb.langs[editLang].video.embed}</div><br/><span class="uk-text-small">${blurb.langs[editLang].video.name}</span>` : " No video"}</p>${
					Object.keys(blurb.langs).length > 1
						? `<p>You also are saving these other language versions:</p>${(function () {
								for (let langKey in blurb.langs) {
									if (langKey != editLang) {
										return `<p class="bold">${languages[langKey]}:</p><p>Headline: ${blurb.langs[langKey].headline}</p><p>Copy: ${blurb.langs[langKey].item}</p><p>Publish date: ${humanDate(blurb.langs[langKey].pubDate)}</p><p>Status: ${blurb.langs[langKey].status === true ? "Active" : "Inactive"}</p><p>Thumbnail${blurb.langs[langKey].thumb && blurb.langs[langKey].thumb.length === 1 ? "s" : ""}:${blurb.langs[langKey].thumb && blurb.langs[langKey].thumb.length ? blurb.langs[langKey].thumb.map(thumb => `<br/><img style="width: 100%; max-width: 300px; height: auto;" src="${thumb.url}"/>`).join("") : ""}</p><p>Video: ${blurb.langs[langKey].video ? `<br/><div style="width: 100%; max-width:300px;">${blurb.langs[langKey].video.embed}</div><br/><span class="uk-text-small">${blurb.langs[langKey].video.name}</span>` : " No video"}</p>`;
									}
								}
						  })()}`
						: ""
				}<p class="bold">Is this the plan?</p>`
			);
			blurb.langs[editLang].updated = new Date().getTime();
			blurb.langs[editLang].updatedBy = author;
			// this always gets updated by current logged in
			// admin user

			blurb.type = "crItem";
			// 'type' is the primary key for this table

			for (let langKey in blurb.langs) {
				if (!blurb.langs[langKey].position) {
					blurb.langs[langKey].position = 1;
				}
			}

			let _blurbs;
			if (id) {
				// this is an edit, so we're upserting values via data service batchWrite

				_blurbs = [
					{
						PutRequest: {
							Item: blurb
						}
					}
				];
			} else {
				// this is a new item so we update positions and batchwrite
				// back to db

				blurb.id = uuid();
				// for batchwrite, new item needs ID before sending

				for (let langKey in blurb.langs) {
					blurb.langs[langKey].position = 1;
					// each version in new blurb
					// defaults to 1st position

					blurbs.forEach(_blurb => {
						if (_blurb.langs[langKey]) {
							_blurb.langs[langKey].position = _blurb.langs[langKey].position + 1;
						}
					});
				}
				// add 1 to position value for each blurb
				// in this blurb's langKeys

				blurbs.push(blurb);
				// add this blurb to the array

				_blurbs = blurbs.map(blurb => {
					return {
						PutRequest: {
							Item: blurb
						}
					};
				});
				// map blurbs to RequestItems array
			}
			const pageSize = 25;
			function sendReq(params, index = 0) {
				return new Promise(async (resolve, reject) => {
					try {
						const response = await request(params, $("#blurb_form"));
						if (index + pageSize < _blurbs.length) {
							index = index + pageSize;
							params.data = _blurbs.slice(index, index + pageSize);
							resolve(sendReq(params, index));
						} else {
							$("#blurb_editor").remove();
							presentBlurbs(blurbs, author, userLevel);
							resolve("Item successfully saved");
						}
					} catch (err) {
						console.error(err);
						reject(err);
					}
				});
			}
			notify(`Saving item to database ...`);
			try {
				const response = await sendReq({
					reqId: "4b9d14f5-1255-4f03-8b6a-da2363fe25ee",
					data: _blurbs.slice(0, pageSize)
				});
				notify(response, "success");
			} catch (err) {
				throw err;
			}
		} catch (err) {
			if (err) {
				console.error("Error saving blurb:", err);
				notify("There was an error saving this blurb", "danger");
			}
		}
	}
	// form passed validation
};
// end processBlurbs function
